import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0333d49d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "description" }
const _hoisted_4 = { class: "info-list" }
const _hoisted_5 = { class: "info-label" }

import { withDefaults } from 'vue'
import { CommonContent } from '@/types/close-account'


export default /*#__PURE__*/_defineComponent({
  __name: 'common-content',
  props: {
    data: { default: () => ({
      title: '',
      infoList: [],
      showSlot: false,
    }) },
    showSlot: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { data: CommonContent, showSlot?: boolean };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.data.title), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.data.description), 1),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.infoList, (item, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(item.label), 1),
          _createElementVNode("div", null, _toDisplayString(item.value), 1)
        ]))
      }), 128)),
      _withDirectives(_createElementVNode("li", null, [
        _renderSlot(_ctx.$slots, "default")
      ], 512), [
        [_vShow, props.showSlot]
      ])
    ])
  ]))
}
}

})